import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';
import { breakpoint } from '../../../../styles/dontgiftguide.styles';
import { doubleSnowflakeURL } from '../../levelOne/SectionGroup/SectionGroup.styles';
import { singleSnowflakeURL } from '../PartnerSection/PartnerSection.styles';

const { fonts } = dggTheme;

export const root = css`
  h4,
  strong {
    font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  }

  ${mediaQuery(
    { min: breakpoint },
    css`
      h4 {
        font-size: ${pxToRem(22)};
      }
      p {
        font-size: ${pxToRem(20)};
      }
    `,
  )}
`;

const oneURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt8e3faef43e013d02/652698e68332d85d500d9cae/1.png';
const twoURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt16c01fdcb13c84ce/652698e6580c6bc2a7ba5b2b/2.png';
const threeURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt6876d16314d8dc39/652698e67a2689811d05cbf1/3.png';
const greenSpeechBubbleURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltd46aed049ff01e99/6526d6df7f5e9ef51527d110/speech-bubble-1.png';
const redSpeechBubbleURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltc8809a4b1690c530/red-speech-bubble.png';

const catURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt4e5752d608581de6/cat-img.png';
const terrariumURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt03f5098fcc0783c0/terrarium-img.png';
const photoURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt4254f40bc61bd05c/photo-img.png';
const biscuitsURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt45b23f7eb51858ae/biscuits-img.png';

const blanketURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltd39ac2fa78e72810/6526e26ad44a280c8efdc369/circle-img-5.png';
const pastyURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt91f86a1d56076da3/6526e26bc2c54b332d7e4b45/circle-img-6.png';

const numberHeight = 190;

export const stepOneAndTwoContainer = css`
  background-image: url(${catURL}), url(${terrariumURL}), url(${singleSnowflakeURL});
  background-repeat: no-repeat;
  background-position: left ${pxToRem(265)}, right ${pxToRem(200)}, center ${pxToRem(230)};
  background-size: ${pxToRem(110)}, ${pxToRem(130)}, ${pxToRem(40)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      background-size: ${pxToRem(250)}, ${pxToRem(300)}, ${pxToRem(40)};
      background-position: left ${pxToRem(200)}, right ${pxToRem(100)}, center ${pxToRem(230)};
    `,
  )}
`;

export const stepOne = css`
  margin: 0 auto 70px;
  padding-top: ${pxToRem(24)};
  padding-left: 100px;
  padding-right: 26px;
  min-height: ${numberHeight + 30}px;
  color: #fff;
  text-align: left;
  background-image: url(${oneURL});
  background-repeat: no-repeat;
  background-position: left ${pxToRem(30)};
  background-size: auto ${numberHeight}px;

  h4 {
    margin: 0;
  }

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(400)};
    `,
  )}
`;

export const stepTwo = css`
  margin: 0 auto;
  padding: ${pxToRem(numberHeight + 10)} 0 ${pxToRem(40)};
  background-image: url(${twoURL}), url(${greenSpeechBubbleURL});
  background-repeat: no-repeat;
  background-position: center top, center bottom;
  background-size: auto ${numberHeight}px, contain;
  position: relative;

  h4,
  p {
    margin: 0 2px 10px 0;
    padding: 0 20px;
    color: #280664;
  }

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(400)};
      padding-bottom: ${pxToRem(60)};
    `,
  )}
`;

export const redSpeechBubble = css`
  margin: 0 auto;
  min-height: ${pxToRem(220)};
  background-image: url(${redSpeechBubbleURL});
  background-repeat: no-repeat;
  background-size: auto ${pxToRem(220)}, contain;
  position: relative;
  top: ${pxToRem(-20)};
  left: ${pxToRem(-20)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(400)};
    `,
  )};
`;

export const stepThreeContainer = css`
  background-image: url(${photoURL}), url(${biscuitsURL});
  background-repeat: no-repeat;
  background-position: left 120px, right 0;
  background-size: 105px, 120px;

  ${mediaQuery(
    { min: breakpoint },
    css`
      background-size: 250px, 300px;
      background-position: left 100px, right 0;
    `,
  )}
`;

export const stepThree = css`
  margin: 0 auto;
  padding-top: ${pxToRem(numberHeight + 60)};
  background-image: url(${threeURL}), url(${doubleSnowflakeURL});
  background-repeat: no-repeat;
  background-position: center ${pxToRem(50)}, left ${pxToRem(20)} top;
  background-size: auto ${numberHeight}px, ${pxToRem(80)};
  color: #fff;

  h4,
  p {
    margin: 0;
    padding: ${pxToRem(10)} ${pxToRem(20)} 0;
  }

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(400)};
      background-size: auto ${numberHeight}px, ${pxToRem(90)};
    `,
  )}
`;

export const spareTheirStorage = css`
  color: #fff;
`;

export const makeItUseful = css`
  margin: 0 auto;
  padding: ${pxToRem(20)} ${pxToRem(10)} 0 ${pxToRem(220)};
  min-height: ${pxToRem(250)};
  color: #fff;
  text-align: left;
  background-image: url(${blanketURL}), url(${singleSnowflakeURL});
  background-repeat: no-repeat;
  background-size: ${pxToRem(205)}, ${pxToRem(25)};
  background-position: left 0, right ${pxToRem(85)} top;

  ${mediaQuery(
    { min: breakpoint },
    css`
      padding-left: ${pxToRem(270)};
      width: ${pxToRem(500)};
      background-position: left center, right top;
      background-size: ${pxToRem(250)}, ${pxToRem(50)};
    `,
  )}
`;

export const tailorIt = css`
  margin: 0 auto;
  padding-top: 20px;
  padding-right: 220px;
  padding-left: 10px;
  min-height: 250px;
  color: #fff;
  text-align: right;
  background-image: url(${pastyURL});
  background-repeat: no-repeat;
  background-size: 205px;
  background-position: right;

  ${mediaQuery(
    { min: breakpoint },
    css`
      padding-right: 270px;
      width: ${pxToRem(450)};
      background-position: right center;
      background-size: 250px;
    `,
  )}
`;

export const wantToKnow = css`
  margin: 0 auto;
  padding: 30px 4px;
  color: #fff;
  line-height: 1.3;

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(400)};
    `,
  )}
`;
